import React, { useState } from "react";
import { Box, IconButton, Menu, MenuItem } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { useTheme } from "@mui/material/styles";
import MenuPanel from "./MenuPanel";
import { Outlet } from "react-router-dom";

const TitleLayout = () => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleMenuOpen = (e: React.MouseEvent<HTMLElement>) => setAnchorEl(e.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const handleHelpNavigation = (label: string) => {
    switch (label) {
      case "Admin Help":
        window.open("https://help.llmasaservice.io/docs/category/adminstrators", "_blank");
        break;
      case "Developer Help":
        window.open("https://help.llmasaservice.io/docs/category/developers", "_blank");
        break;
      case "Contact Support Team":
        window.open("https://help.llmasaservice.io/docs/category/contact", "_blank");
        break;
      default:
        break;
    }
    handleMenuClose();
  };

  return (
    <>
      {/* Main layout structure */}
      <Box
        sx={{
          display: "flex",
          height: "100vh",
          width: "100vw",
          overflow: "hidden", // Prevent outer scrolling
        }}
      >
        {/* Fixed left sidebar */}
        <Box
          sx={{
            width: "250px",
            flexShrink: 0,
            height: "100vh",
            overflow: "hidden", // Prevent sidebar scrolling
          }}
        >
          <MenuPanel />
        </Box>

        {/* Main content area with fixed header */}
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            height: "100vh",
            overflow: "hidden", // Prevent overflow outside content area
          }}
        >
          {/* Fixed top bar */}
          <Box
            sx={{
              height: "50px",
              backgroundColor: theme.palette.background.paper,
              flexShrink: 0, // Prevent shrinking
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: 1,
              paddingRight: 2,
              borderBottom: `1px solid ${theme.palette.divider}`,
              zIndex: 2, // Ensure it stays above content
            }}
          >
            {/* Help icon with popup menu */}
            <IconButton onClick={handleMenuOpen}>
              <HelpOutlineIcon />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
            >
              <MenuItem onClick={() => handleHelpNavigation("Admin Help")}>
                Admin Help
              </MenuItem>
              <MenuItem onClick={() => handleHelpNavigation("Developer Help")}>
                Developer Help
              </MenuItem>
              <MenuItem onClick={() => handleHelpNavigation("Contact Support Team")}>
                Contact Support Team
              </MenuItem>
            </Menu>
          </Box>

          {/* Scrollable content area */}
          <Box
            sx={{
              flexGrow: 1,
              overflow: "auto", // Allow content to scroll
              padding: 2,
              boxSizing: "border-box",
            }}
          >
            <Outlet />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default TitleLayout;
